export enum EventId {
  Next = 'Next',
  Back = 'Back',
}

export enum StateId {
  Instructions = 'Instructions',
  Form = 'Form',
  Colors = 'Colors',
  Fonts = 'Fonts',
  Images = 'Images',
  Voice = 'Voice',
  Finished = 'Finished',
  Done = 'Done',
}
